import { number, object } from "prop-types";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";
import { generateResourceId } from "@repo/structure";
import { useEstimateEditorSettings} from "@tools";
import { AddButtonFull } from "@components";
import { Grid } from "@material-ui/core";
import { TimelineTeamMemberChart } from "./TimelineTeamMemberChart";
import { TimelineSectionChartContainer } from "./TimelineSectionChartContainer";
import { Person } from "@assets";
import { useMemo } from "react";
import classnames from "classnames";
import { makeStyles } from "@material-ui/styles";

export const TimelineWorkTypeChart = observer(({
  index,
  section,
  workType,
  blocksStartDate,
}) => {
  const { t } = useTranslation();
  const { allowEdition } = useEstimateEditorSettings();
  const classes = useStyle();

  const { visibleTeamMembers } = workType;

  const expandable = useMemo(() => (
    allowEdition || visibleTeamMembers.length > 0
  ), [ allowEdition, visibleTeamMembers.length ]);

  const handleTeaMemberAdd = () => {
    workType.addTeamMember(generateResourceId())
  }

  return (
    <TimelineSectionChartContainer
      element={workType}
      index={index}
      height="medium"
      type="workType"
      useValueMode
      blurOnExpand={visibleTeamMembers.length > 0}
      expandable={expandable}
      editable={!visibleTeamMembers.length}
      blocksStartDate={blocksStartDate}
      labelActions={
        visibleTeamMembers.length > 0 &&
        <Grid item container alignItems="center" className="ml-2 w-max min-w-max font-bold">
          <Person />
          <span className="ml-0-5 line-height-xs">
            { visibleTeamMembers.length }
          </span>
        </Grid>
      }
    >
      {visibleTeamMembers.map((teamMember, index) => (
        <TimelineTeamMemberChart
          key={teamMember.id}
          index={index}
          section={section}
          teamMember={teamMember}
          workType={workType}
          previousTeamMember={visibleTeamMembers[index - 1]}
          nextTeamMember={visibleTeamMembers[index + 1]}
          blocksStartDate={workType.startDay}
        />
      ))}
      {
        allowEdition &&
        <AddButtonFull
          color="secondary"
          onClick={handleTeaMemberAdd}
          className={classnames("ml-0-5 apply-events", classes.sticky)}
        >
          {t("views.editor.timeline_table.work_resource_add")}
        </AddButtonFull>
      }
    </TimelineSectionChartContainer>
  );
})

TimelineWorkTypeChart.propTypes = {
  index: number.isRequired,
  section: object.isRequired,
  workType: object.isRequired,
  blocksStartDate: object,
};

const useStyle = makeStyles(() => ({
  sticky: {
    position: "sticky",
    left: 0,
  },
}));